import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { useLayoutEffect, useRef } from 'react';

gsap.registerPlugin(ScrollTrigger);

export default function About() {
  const root = useRef(null);

  useLayoutEffect(() => {
    if (!root.current || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return undefined;

    const context = gsap.context(() => {
      gsap.from('.about__portrait', {
        clipPath: 'inset(0 0 100% 0)',
        y: 100,
        duration: 1.3,
        ease: 'power4.out',
        scrollTrigger: {
          trigger: root.current,
          start: 'top 68%'
        }
      });

      gsap.from('.about__text > *', {
        y: 42,
        opacity: 0,
        stagger: 0.12,
        duration: 0.9,
        ease: 'power3.out',
        scrollTrigger: {
          trigger: '.about__text',
          start: 'top 72%'
        }
      });

      gsap.to('.about__portrait img', {
        yPercent: -12,
        scale: 1.08,
        ease: 'none',
        scrollTrigger: {
          trigger: root.current,
          start: 'top bottom',
          end: 'bottom top',
          scrub: true
        }
      });
    }, root);

    return () => context.revert();
  }, []);

  return (
    <section className="about" id="about" ref={root}>
      <div className="about__marker">ABOUT / STANCE / NOISE</div>
      <figure className="about__portrait">
        <img src="/media/me.jpg" alt="Stefan Maldet" loading="lazy" decoding="async" />
      </figure>
      <div className="about__text">
        <p className="mono-label">Behind the eye</p>
        <h2>Stefan Maldet arbeitet nicht auf glatte Perfektion hin. Er sucht Haltung.</h2>
        <p>
          Seine Bilder bewegen sich zwischen Ästhetik und Kante, zwischen Inszenierung und Authentizität. Sie
          sollen nicht nett wirken, sondern spürbar. Nicht nur zeigen, sondern eine Stimmung hinterlassen.
        </p>
        <p>
          Der Blick kommt aus starkem kreativem, markenorientiertem und visuellem Denken: Komposition, Tonalität
          und Atmosphäre werden nicht zufällig gesetzt, sondern als Haltung geführt. Das Ergebnis ist roh,
          präzise und bewusst unpoliert.
        </p>
      </div>
    </section>
  );
}
